import u from "./index4.js";
import { openBlock as o, createElementBlock as t, normalizeClass as d, createElementVNode as i, renderSlot as l, createVNode as m, Transition as c, withCtx as w, withDirectives as k, Fragment as h, renderList as f, toDisplayString as p, createCommentVNode as s, withModifiers as y, vShow as C } from "vue";
import "./index5.js";
import v from "./index6.js";
const g = ["id"], E = ["id"], b = { class: "dropdown-menu-list" }, T = ["onClick"], M = { class: "dropdown-menu-item-title" }, $ = ["href", "target", "onClick"], V = { class: "dropdown-menu-item-title" };
function I(e, r, L, N, A, B) {
  return o(), t("div", {
    class: d([
      "dropdown-menu",
      e.isExpandOnClickType ? "dropdown-menu-expand-on-click" : "dropdown-menu-expand-on-hover",
      e.showMenuItems && e.isExpandOnClickType ? "dropdown-menu-expanded" : "",
      e.menuItems && e.menuItems.length > 0 ? "" : "no-items"
    ]),
    id: e.uniqueId,
    onClick: r[0] || (r[0] = (...n) => e.toggleMenuItemsVisibility && e.toggleMenuItemsVisibility(...n))
  }, [
    i("span", {
      class: d([
        "dropdown-menu-title",
        e.hasArrowIcon ? "dropdown-menu-title-icon" : ""
      ])
    }, [
      l(e.$slots, "title", {}, void 0, !0)
    ], 2),
    i("div", {
      class: "dropdown-menu-list-wrapper",
      id: e.listWrapperId
    }, [
      m(c, {
        name: "expand",
        onEnter: e.enter,
        onAfterEnter: e.afterEnter,
        onLeave: e.leave
      }, {
        default: w(() => [
          k(i("ul", b, [
            (o(!0), t(h, null, f(e.visibleMenuItems, (n, a) => (o(), t("li", {
              key: a,
              class: "dropdown-menu-item"
            }, [
              n.type === e.menuItemTypes.Button ? (o(), t("button", {
                key: 0,
                class: "dropdown-menu-item-button",
                onClick: n.handleClick
              }, [
                i("span", M, p(n.title), 1)
              ], 8, T)) : s("", !0),
              n.type === e.menuItemTypes.Link ? (o(), t("a", {
                key: 1,
                href: n.link,
                target: n.target,
                onClick: y(n.handleClick, ["prevent"]),
                class: "dropdown-menu-item-link"
              }, [
                i("span", V, p(n.title), 1)
              ], 8, $)) : s("", !0),
              n.type === e.menuItemTypes.Custom ? l(e.$slots, n.slotName, {
                key: 2,
                menuItem: n
              }, void 0, !0) : s("", !0)
            ]))), 128))
          ], 512), [
            [C, e.isExpandOnClickType ? e.showMenuItems : !0]
          ])
        ]),
        _: 3
      }, 8, ["onEnter", "onAfterEnter", "onLeave"])
    ], 8, E)
  ], 10, g);
}
const q = /* @__PURE__ */ v(u, [["render", I], ["__scopeId", "data-v-feb1bb2d"]]);
export {
  q as default
};
//# sourceMappingURL=index2.js.map
